import React from 'react';
import getFullUserName from 'utils/getFullUserName';
import Flag from 'components/Flag';
import Text from 'components/Text';
import PageTitle from 'components/PageTitle';
import Avatar from 'components/Avatar';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UserPageHeader(_ref) {
  var email = _ref.email,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    pictureUrl = _ref.pictureUrl;
  var fullName = getFullUserName({
    first_name: firstName,
    last_name: lastName
  });
  var title = fullName || email;
  var subtitle = fullName ? email : null;
  return /*#__PURE__*/_jsxs(Flag, {
    align: "center",
    spacing: "m",
    token: /*#__PURE__*/_jsx(Avatar, {
      shady: true,
      pictureUrl: pictureUrl,
      size: "big"
    }),
    mb: "m",
    children: [/*#__PURE__*/_jsx(PageTitle, {
      size: "large",
      text: title || '',
      children: title
    }), subtitle && /*#__PURE__*/_jsx(Text, {
      dimmed: true,
      overflow: "wrap",
      children: subtitle
    })]
  });
}
export default UserPageHeader;